'use client';

import { ISalePageDetailResponseGachaReward } from '@/api/types';
import { Element } from '@vuddy/components';
import * as styles from './gachaProbabilityTableStockBased.css';

interface IGachaProbabilityTableStockBasedProps {
  rewards: ISalePageDetailResponseGachaReward[];
  totalStock: number;
}

export const GachaProbabilityTableStockBased = ({
  rewards,
  totalStock,
}: IGachaProbabilityTableStockBasedProps) => {
  return (
    <Element className={styles.table} color="whitePrimary">
      <Element
        className={styles.tableHeaderGroup}
        typography="captionBase"
        backgroundColor="whiteTertiary">
        <div className={styles.tableCell}>종류</div>
        <div className={styles.tableCell}>등급</div>
        <div className={styles.tableCell}>재고</div>
        <div className={styles.tableCell}>
          <div>실시간</div>
          <div>확률(%)</div>
        </div>
        <div className={styles.tableCell}>리워드</div>
      </Element>
      <Element
        className={styles.tableRowGroup}
        typography="captionBaseAccent"
        backgroundColor="whiteQuaternary">
        {rewards.map((reward, i) => {
          const stock = reward.stock;
          const totalQuantity = stock?.totalQuantity || 0;
          const usedQuantity = stock?.usedQuantity || 0;
          const availableQuantity = totalQuantity - usedQuantity || 0;
          const percentage = (availableQuantity / totalStock) * 100 || 0;

          return (
            <div
              className={styles.tableRow}
              key={reward.grade + reward.probability + i}>
              <Element
                typography="captionSmallAccent"
                className={styles.tableCell}>
                디지털{i + 1}
              </Element>
              <Element
                typography="captionSmallAccent"
                className={styles.tableCell}>
                {reward.grade}
              </Element>
              <Element
                typography="captionSmallAccent"
                className={styles.tableCell}>
                {availableQuantity?.toLocaleString() || 0}
              </Element>
              <Element
                typography="captionSmallAccent"
                className={styles.tableCell}>
                {percentage.toFixed(10)}%
              </Element>
              <Element
                typography="captionSmallAccent"
                className={styles.tableCell}>
                {reward.hasBonusGifts ? '제공' : '미제공'}
              </Element>
            </div>
          );
        })}
      </Element>
    </Element>
  );
};
